// HTTP responses and hub messages can arrive in a different order than commits.
export const selectRoomSnapshot = (current, incoming, roomId, playerId, membershipVersion) => {
    if (!incoming) return null;
    if (incoming.roomId !== roomId) return current;
    const member = incoming.players?.find(p => p.playerId === playerId);
    if (!member?.isJoined || Number(member.membershipVersion) !== Number(membershipVersion)) return current;
    if (current && Number(incoming.stateVersion ?? -1) < Number(current.stateVersion ?? -1)) return current;
    return incoming;
};
